import { forwardRef } from 'react';
import { css, type Theme } from '@emotion/react';

import type { HTMLAttributes, RefAttributes, CSSProperties } from 'react';
import type { SerializedStyles } from '@emotion/serialize';

export type ProgressBarProps = HTMLAttributes<HTMLDivElement> &
  RefAttributes<HTMLDivElement> & {
    progress?: number;
  };

const progressBarStyles = (theme: Theme): SerializedStyles => css`
  height: 8px;
  width: 100%;
  min-height: 8px; /* hack for safari */
  background: ${theme.palette.colors.gray[300]};
  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
  position: relative;

  &::before {
    content: '';
    background: ${theme.palette.colors.primary};
    position: absolute;
    height: 100%;
    width: var(--progress);
    transition: width 0.4s;
  }
`;

export const StyledProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>(
  function StyledProgressBar({ progress = 0, ...props }, ref) {
    const style = {
      '--progress': `${Math.max(2, Math.min(progress, 100))}%`,
    } as CSSProperties;

    return (
      <div
        {...props}
        role="progressbar"
        aria-valuemin={0}
        aria-valuenow={progress * 100}
        aria-valuemax={100}
        css={progressBarStyles as any}
        style={style}
        ref={ref}
      />
    );
  },
);
